import { Box, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import SwitchButton from "../UIElements/switch-button";
import useResponsive from "../../hooks/useResponsive";
import { useMutation } from "@tanstack/react-query";
import { useNotificationService } from "../notification";
import {
  apiToogleEmailNotification,
  apiTooglePushNotification,
} from "../../api/users";
import { useAuth } from "../../hooks/useAuth";

const Notification = () => {
  const isMedium = useResponsive("down", "md", "xs");
  const { showNotification } = useNotificationService();
  const { token } = useAuth();
  const [user_data, setUser_Data] = useState({
    email: false,
    notification: false,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      if (user_data.email) {
        Emailmutation.mutate(user_data.email);
      }
    }, 3000);

    return () => {
      clearTimeout(handler);
    };
  }, [user_data.email]);
  useEffect(() => {
    const handler = setTimeout(() => {
      if (user_data.email) {
        Notificationmutation.mutate(user_data.notification);
      }
    }, 3000);

    return () => {
      clearTimeout(handler);
    };
  }, [user_data.notification]);
  const handleEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUser_Data((prev) => ({ ...prev, email: event.target.checked }));
  };
  const handleNotification = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUser_Data((prev) => ({ ...prev, notification: event.target.checked }));
  };

  const Emailmutation = useMutation({
    mutationFn: (isActive: boolean) => apiToogleEmailNotification(isActive),
    onSuccess: (data) => {
      // Handle error
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
      }
      //  Handle success
      if ("data" in data) {
        showNotification(data?.data?.message ?? "", "success");
      }
    },
    onError: (error) => {
      console.error("Email Notification failed", error);
      // Handle error
      showNotification("Email Notification failed", "error");
    },
  });
  const Notificationmutation = useMutation({
    mutationFn: (isActive: boolean) => apiTooglePushNotification(isActive),
    onSuccess: (data) => {
      // Handle error
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
      }
      //  Handle success
      if ("data" in data) {
        showNotification(data?.data?.message ?? "", "success");
      }
    },
    onError: (error) => {
      console.error("Notification update failed", error);
      // Handle error
      showNotification("Notification update failed", "error");
    },
  });
  return (
    <Box
      sx={{
        width: isMedium ? "85%" : "550px",
        marginY: 4,
        marginX: 2,
      }}
    >
      <Typography
        variant="h4"
        sx={{
          color: "#000E2C",
          fontWeight: 700,
          fontFamily: "Inter",
        }}
      >
        Notification
      </Typography>

      <Box sx={{ my: 4 }}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between "
        >
          <Typography
            sx={{
              fontFamily: "Lexend",
              fontSize: "14px",
              lineHeight: "23px",
              letterSpacing: "-0.23999999463558197px",
              color: "#000",
              fontWeight: 400,
            }}
          >
            Push Notification
          </Typography>
          <SwitchButton
            value={user_data.notification}
            handleChange={handleNotification}
          />
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between "
        >
          <Typography
            sx={{
              fontFamily: "Lexend",
              fontSize: "14px",
              lineHeight: "23px",
              letterSpacing: "-0.23999999463558197px",
              color: "#000",
              fontWeight: 400,
            }}
          >
            Email Notification
          </Typography>
          <SwitchButton value={user_data.email} handleChange={handleEmail} />
        </Stack>
      </Box>
    </Box>
  );
};

export default Notification;
